import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: true,
  selector: 'molec-tabs',
  imports: [CommonModule],
  templateUrl: './tabs.molec.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsMolec implements OnInit {
  @Input() tabs!: { id: number; name: string; path: string }[];
  @Input() selectedTab = '';
  @Input() className = {
    tab: 'outline-none cursor-pointer text-lg md:text-2xl roboto px-6',
    tabNormal: 'text-gray-500',
    tabActive: 'text-primary border-b-4 border-primary pb-2.5',
    tabDiv: 'px-6',
    tabDivParent: 'flex',
  };
  @Output() action = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
}
